<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-book mr-2" />Log Barcode</h5>
            <hr />
            <b-row>
                <b-col md="3">
                    <b-form-group label="Sumber Barcode">
                        <b-form-select v-model="filter.source" :options="optFilterSource" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Aksi">
                        <b-button variant="primary" @click="getItems()">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                @sort-changed="onSortChanged"
                responsive class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada rekaman cetak barcode.
                </template>
                <template v-slot:cell(created_at)="row">
                    {{ $helper.parseDate(row.item.created_at) }}, {{ $helper.parseHourMinute(row.item.created_at) }}
                </template>
                <template v-slot:cell(total_item)="row">
                    Jumlah barang: <strong>{{ row.item.total_item }}</strong>
                </template>
                <template v-slot:cell(source)="row">
                    <b-badge :variant="getSourceBadge(row.item.source)[0]" class="custom-badge-secondary">{{ getSourceBadge(row.item.source)[1] }}</b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <b-button size="sm" variant="primary" v-b-tooltip.hover.top title="Tampilkan Barcode" :disabled="isSubmitting" @click="showModalBarcode(row.item.id)">
                        <i class="fa fa-fw fa-print" />
                    </b-button>
                </template>
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" @page-change="onPageChange" />
        </b-card>
        <b-modal id="m-barcode" title="Cetak Barcode" centered no-close-on-backdrop no-close-on-esc hide-footer hide-header-close>
            Silahkan cetak barcode dibawah ini.
            <br /><br />
            <iframe :src="getBarcodeLink()" height="300px" width="100%" />
            <div class="mt-4">
                <b-row>
                    <b-col md="12" class="text-right">
                        <b-button variant="primary" @click="closeModalBarcode">
                            Tutup
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            filter: {
                source: ""
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "created_at", label: "Tanggal Cetak", sortable: true },
                { key: "total_item", label: "Detail", sortable: true },
                { key: "source", label: "Sumber Barcode", sortable: true },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optFilterSource: [
                { value: "", text: "Semua" },
                { value: "1", text: "Adjust Barcode" },
                { value: "2", text: "Pindah Barang" },
                { value: "5", text: "Reset Inventory" },
                { value: "6", text: "Approve Sekaligus Temuan" }
            ],

            barcodeLink: "",
            barcodeLinkDamage: "",

            barcodeToggleCooldown: false

        }
    },

    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()

            Promise.all([getItems]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                this.initStatus = -1
            })

        },

        getBarcodeLink() {
            return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLink}`
        },


        showModalBarcode(id) {

            this.barcodeLink = "/umgtbrcdb/" + id
            this.barcodeLinkDamage = "/umgtbdmgb/" + id
            this.$bvModal.show("m-barcode")

        },

        closeModalBarcode() {

            this.$bvModal.hide("m-barcode")

        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if(!this.$helper.isBlank(this.filter.source)) {
                param += "&filterSource=" + this.filter.source
            }

            if(!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("log-barcode" + param).then(res => {
                this.items = res.data.data.items
                this.totalRows = res.data.data.total
                sessionStorage.setItem("listLogBarcodeFilter", JSON.stringify(this.filter))
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        getSourceBadge(source) {
            switch(source) {
                case 1: return ["secondary", "ADJUST BARCODE"]
                case 2: return ["secondary", "PINDAH BARANG"]
                case 3: return ["secondary", "ADJUST BARCODE"]
                case 4: return ["secondary", "PINDAH BARANG"]
                case 5: return ["secondary", "RESET INVENTORY"]
                case 6: return ["secondary", "APPROVE SEKALIGUS TEMUAN"]
            }
        }

    },

    created() {
        if(!this.$helper.isBlank(sessionStorage.getItem("listLogBarcodeFilter"))){
            this.filter = JSON.parse(sessionStorage.getItem("listLogBarcodeFilter"))
        }
        this.init()
    }
}
</script>
